import { render } from "./Resources.vue?vue&type=template&id=7874f46b&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=7874f46b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7874f46b"

export default script